let children = [];
//------------ TESORERIA ------------
children.push({
    path: "/finance/paymentScheduling",
    name: "TSR_PROGRAMACION_DE_PAGOS",
    component: () =>
        import("@/views/Treasury/PaymentScheduling/PaymentScheduling.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Finanzas", disabled: true },
            { text: "Programación de Pagos", href: "/finance/paymentScheduling" },
        ],
    },
});

children.push({
    path: "/finance/presupuestos",
    name: "TRS_BUDGET",
    component: () =>
        import("@/views/Treasury/TrsBudget/TrsBudget.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Finanzas", disabled: true },
            { text: "Presupuestos", href: "/finance/presupuestos" },
        ],
    },
});

export { children };